import React, { SyntheticEvent } from 'react';
import BlurCircularIcon from '@mui/icons-material/BlurCircular';
import BlurLinearIcon from '@mui/icons-material/BlurLinear';
import { Box, Slider, Typography } from '@mui/material';
import { BackgroundBlurIntensityControlSXStyles } from './style';

interface BackgroundBlurIntensityControlProps {
  ariaLabel: string;
  blurIntensity: number;
  disabled?: boolean;
  label: string;
  onChange: (value: number) => void;
}

export function BackgroundBlurIntensityControl({
  ariaLabel,
  blurIntensity,
  disabled,
  label,
  onChange,
}: BackgroundBlurIntensityControlProps) {
  const {
    backgroundBlurIntensityControlContainer,
    backgroundBlurIntensityControlSurface,
    backgroundBlurIntensityControlHeader,
    backgroundBlurIntensityControlLabel,
    backgroundBlurIntensityControlRow,
    backgroundBlurIntensityControlIcon,
    backgroundBlurIntensityControlSlider,
  } = BackgroundBlurIntensityControlSXStyles;

  const handleSliderChange = (_event: Event, value: number | number[]) => {
    if (typeof value === 'number') {
      onChange(value);
    }
  };

  const stopMenuEvent = (event: SyntheticEvent) => {
    event.stopPropagation();
  };

  return (
    <Box
      sx={backgroundBlurIntensityControlContainer}
      onClick={stopMenuEvent}
      onMouseDown={stopMenuEvent}
      onKeyDown={stopMenuEvent}
    >
      <Box sx={backgroundBlurIntensityControlSurface}>
        <Box sx={backgroundBlurIntensityControlHeader}>
          <Typography sx={backgroundBlurIntensityControlLabel}>{label}</Typography>
        </Box>
        <Box sx={backgroundBlurIntensityControlRow}>
          <BlurLinearIcon sx={backgroundBlurIntensityControlIcon} />
          <Slider
            aria-label={ariaLabel}
            min={1}
            max={25}
            step={1}
            value={blurIntensity}
            onChange={handleSliderChange}
            disabled={disabled}
            sx={backgroundBlurIntensityControlSlider}
          />
          <BlurCircularIcon sx={backgroundBlurIntensityControlIcon} />
        </Box>
      </Box>
    </Box>
  );
}
